// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//
import BaseService from '@core/services/base';
import { NotificationType, showNotification } from '@shared/components/Notification';
import AssetVisitInfo, { AssetVisitInfoDTO } from '@shared/models/asset-visit-info';
import { errObj2Str } from '@shared/utils/common';
import Axios from 'axios';
import sortBy from 'lodash/sortBy';

// Get list of all assetVisitInfo from portal-api.
export default class AssetVisitInfoService extends BaseService<AssetVisitInfoDTO, AssetVisitInfo> {
  static diToken = Symbol('assetVisitInfo-service');

  constructor() {
    super({ domainArea: 'asset-visit', Model: AssetVisitInfo }); // this.urlPrefix will be set to domainArea.
  }

  // Get a list of AssetVisitInfo from portal-api.
  // If idList is given, return rows with matching ids.  Otherwise, return all rows.
  async getAssetVisitInfo(idList: Array<number>): Promise<Array<AssetVisitInfo> | undefined> {
    //console.log("*** send request to: ", this.urlPrefix, idList);
    const { data, status } = await Axios.post<Array<AssetVisitInfoDTO>>(this.urlPrefix, idList);

    if(status == 200) {
      //console.log("*** data: ", data);
      return sortBy(data, 'id').map((avDTO) => new AssetVisitInfo(avDTO));
    }
    else {
      console.log("*** Could not load VisitInfo. rc: ", status);
      return undefined;
    }
  }

  // Send request to update a AssetVisitInfo row to portal-api.
  async updateAssetVisitInfo(avDTO: Partial<AssetVisitInfoDTO>): Promise<boolean> {
    try {
      const { status } = await Axios.post<AssetVisitInfoDTO>(this.urlPrefix + "/update", avDTO);
      //console.log("*** update status from: ", this.urlPrefix, avDTO, status);
      if(status != 200) {
        showNotification(`Failed to update AssetVisitInfo with error code: ${status}.`, NotificationType.error);
        return false;
      }
      else {
        return true;
      }
    }
    catch(err) {
      showNotification(errObj2Str(err), NotificationType.error);
      return false;
    }
  }

}